import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from "gatsby"

const Container = styled.div`
  background: #DEDEDE;
  padding: ${({ $compactTop }) => $compactTop ? '0 0 40px' : '40px 0'};
  height: ${({ $compactTop }) => $compactTop ? '134px' : '174px'};
  @media (max-width: 789px) {
    height: ${({ $compactTop }) => $compactTop ? '260px' : '300px'};
  }
  .wrapper {
    max-width: 1200px;
    padding: 0 15px;
    display: flex;
    height: 100%;
    margin: 0 auto 40px;
  }
  a {
    display: flex;
    height: 100%;
    width: 100%;
    .item {
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      display: none;

      @media (max-width: 789px) {
        &.mobile {
          display: block;
        }
      }

      @media (min-width: 789px) {
        &.desktop {
          display: block;
        }
      }
    } 
  }
`;

export default function BannerInbound({ compactTop = false, variant = 'default' }) {
  const result = useStaticQuery(graphql`
    {
      central: prismicCentralDeBanners(lang: { eq: "pt-br" }) {
        data {
          meu_ambiente_faixa_superior {
            imagem_desktop {
              url
            }
            imagem_mobile {
              url
            }
            link {
              url
            }
            ordem
            ativo
          }
          meu_ambiente_faixa_inferior {
            imagem_desktop {
              url
            }
            imagem_mobile {
              url
            }
            link {
              url
            }
            ordem
            ativo
          }
        }
      }
      banner: prismicCampanhaHomeMeusAmbientes {
        data {
          banner {
            url
          }
          banner_mobile {
            url
          }
          link {
            url
          }
        }
      }
      bannerHome: allPrismicBannerHomeMeuAmbients {
        edges {
          node {
            data {
              imagem_desktop_inferior {
                url
              }
              imagem_mobile_inferior {
                url
              }
              link_banner_inferior {
                url
              }
            }
          }
        }
      }
    }
  `)
  
  const { central, banner, bannerHome } = result
  const isBottomBanner = variant === 'bottom'
  const centralizedBannerGroup = central && central.data
    ? central.data[isBottomBanner ? 'meu_ambiente_faixa_inferior' : 'meu_ambiente_faixa_superior'] || []
    : []
  const centralizedBanner = centralizedBannerGroup
    .filter(({ ativo, imagem_desktop }) => ativo !== false && imagem_desktop && imagem_desktop.url)
    .sort((first, second) => (first.ordem || 0) - (second.ordem || 0))[0]
  const bottomBanner = bannerHome.edges.find(({ node }) => (
    node.data.imagem_desktop_inferior && node.data.imagem_desktop_inferior.url
  ))
  const bottomBannerData = bottomBanner && bottomBanner.node.data
  const desktopImage = centralizedBanner
    ? centralizedBanner.imagem_desktop
    : isBottomBanner && bottomBannerData
    ? bottomBannerData.imagem_desktop_inferior
    : banner.data.banner
  const mobileImage = centralizedBanner
    ? centralizedBanner.imagem_mobile || centralizedBanner.imagem_desktop
    : isBottomBanner && bottomBannerData
    ? bottomBannerData.imagem_mobile_inferior || bottomBannerData.imagem_desktop_inferior
    : banner.data.banner_mobile
  const link = centralizedBanner
    ? centralizedBanner.link
    : isBottomBanner && bottomBannerData
    ? bottomBannerData.link_banner_inferior
    : banner.data.link

  return (
    <Container $compactTop={compactTop}>
      <div className="wrapper flex">
        <a href={link && link.url} target="_blank" rel="noreferrer">
          <div className="item desktop" style={ { backgroundImage: `url(${desktopImage && desktopImage.url})`}}></div>
          <div className="item mobile" style={ { backgroundImage: `url(${mobileImage && mobileImage.url})`}}></div>
        </a>
      </div>
    </Container>
  )
}
